export const mateGuideLayoutV2 = [
  {
    id: 'platformFunctionEntry',
    element: '#platformFunctionEntry',
    desc: '搜索、通知等常用入口在这里',
    placement: 'right',
  },
  {
    id: 'sidebarMoreFunction',
    element: '#sidebarMoreFunction',
    desc: '试试点击...，完成更多应用操作',
    placement: 'right',
  },
  {
    id: 'switchSidebarCollapse',
    element: '#switchSidebarCollapse',
    desc: '点击可缩小侧边栏宽度',
    placement: 'top',
  },
];
